/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Gespeicherte Route`
};

const en_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Saved itinerary`
};

const es_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerario guardado`
};

const fr_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Itinéraire sauvegardé`
};

const it_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerario salvato`
};

const nl_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Opgeslagen route`
};

const pt_bookmark__itinerary__saved = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerário guardado`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary__saved = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__itinerary__saved(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__itinerary__saved", locale)
	if (locale === "de") return de_bookmark__itinerary__saved(inputs)
	if (locale === "en") return en_bookmark__itinerary__saved(inputs)
	if (locale === "es") return es_bookmark__itinerary__saved(inputs)
	if (locale === "fr") return fr_bookmark__itinerary__saved(inputs)
	if (locale === "it") return it_bookmark__itinerary__saved(inputs)
	if (locale === "nl") return nl_bookmark__itinerary__saved(inputs)
	return pt_bookmark__itinerary__saved(inputs)
};